import Slider from "../utils/Slider";
import { Title, Section } from "@vshp/ui-components";
import { formatDate, formatTime } from "../utils/format-date";

function Events({ events }) {
  const settings = {
    slidesToShow: 3,
    arrows: true,
    infinite: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1220,
        settings: {
          arrows: false,
          slidesToShow: 3,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1075,
        settings: {
          arrows: false,
          slidesToShow: 2,
          variableWidth: false,
        },
      },
      {
        breakpoint: 920,
        settings: {
          arrows: false,
          slidesToShow: 1,
          variableWidth: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          variableWidth: true,
        },
      },
    ],
  };

  return (
    <Section border={true}>
      <Title type="h2">События</Title>

      <div className="events">
        <Slider className="events__slider slider__dots_accent" sliderSettings={settings}>
          {events.map(({ name, place, start_at, end_at, extra }, key) => (
            <div className="slider__item" key={key}>
              <div className="events__item-wrap">
                <div className="events__item">
                  <div className="events__item-body">
                    <div className="events__item-header">
                      <div className="events__item-title">Событие</div>
                      <div className="events__item-subtitle">{name}</div>
                    </div>
                    <div className="events__item-row">
                      <div className="events__item-title">дата и время проведения</div>
                      <div className="events__item-subtitle">
                        {formatDate("ru", start_at)}, {formatTime("ru", start_at)} - {formatTime("ru", end_at)}
                      </div>
                    </div>
                    <div className="events__item-row">
                      <div className="events__item-title">Аудитория</div>
                      <div className="events__item-subtitle">{place}</div>
                    </div>
                  </div>
                  {extra && (
                    <a className="btn btn_primary events__item-more" href={extra} target="_blank" rel="noopener noreferrer">
                      Узнать подробнее
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </Section>
  );
}

export default Events;
